import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MyDataTable from "components/DataTable";
import PageTitle from "components/PageTitle";
import tableData from "DBTables/commessa.json"

import Gestione from "./gestione";

import * as ajax from "helpers/ajax";


export default class GestioneMezzi extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listMezzi: [],
            listOperai:[],

            selectedMezzo: null,

            openReport: false,
            currentDate:this.props.selectedDate ? new Date(this.props.selectedDate) : new Date(),
        };

    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("mezzis", this.loadListMezzi)
        ajax.ajaxGetStrapi("operaios", this.loadListOperai)

    }

    loadListOperai = (response) => {
        this.setState({ listOperai: response.data }, this.checkParam) 
    }

    loadListMezzi = (response) => {
        this.setState({listMezzi:response.data}, this.checkParam)
    }

    checkParam = () => {
        if (this.state.listMezzi.length <= 0) {return}
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let id = params.get('id');

        if (this.props.selectedMezzo) {
            id = this.props.selectedMezzo;
        }

        this.state.listMezzi.forEach((el) => {
            if (el.id == id) {
                let selectedMezzo = {
                    "label": el.marca,
                    "id": el.id
                }

                this.setState({ selectedMezzo: selectedMezzo })
                return
            }
        })

    }

    listMezziArray = () => {
        let arr = [];
        this.state.listMezzi.map((el) => {
            arr.push({
                "label": el.marca,
                "id": el.id
            })
        })

        arr.sort((a, b) => a.label.localeCompare(b.label))

        return arr
    }

    render() {


        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={"Gestione Mezzi"}
                    icon={"local_shipping"}
                    backButton={this.props.backFunction}
                />

                <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={this.listMezziArray()}
                        renderInput={(params) => <TextField {...params} label="Seleziona Mezzo" />}
                        value={this.state.selectedMezzo ? this.state.selectedMezzo.label : ""}
                        onChange={(event, newValue) => {
                            this.setState({ selectedMezzo: newValue })
                        }}
                    />
                </MDBox>

                {this.state.selectedMezzo ?
                    <Gestione
                        setDateCallback={(val) => this.setState({currentDate:val})}
                        selectedDate={this.state.currentDate}
                        key={this.state.selectedMezzo.id}
                        id={this.state.selectedMezzo.id}
                        operai={this.state.listOperai} />
                    : null
                }
            </DashboardLayout>
        )
    }
}


